/**
 * Module dependencies.
 */

import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { queryKeys } from 'src/core/constants/query-keys';
import { ExtendedAxiosConfig, axiosInstance, getApiEndpoint } from 'src/core/utils/requests';
import { User } from 'src/types/user';

/**
 * Export `getMe` request.
 */

export async function getMe(options?: ExtendedAxiosConfig): Promise<User> {
  const response = await axiosInstance.get(getApiEndpoint('getMe'), options);

  return response?.data as User;
}

/**
 * Export `useMe` hook.
 */

export function useMe(options?: Omit<UseQueryOptions<User>, 'queryFn' | 'queryKey'>) {
  return useQuery({
    queryFn: () => getMe(),
    queryKey: queryKeys.me,
    ...options
  });
}
